export default [
  {
    src: "/img/gallery/witalyshipping2.jpg",
    alt: "Clearing & Forwarding",
    caption: "Clearing & Forwarding",
    width: 1532,
    height: 1500
  },
  {
    src:
      "/img/gallery/witalyshipping3.jpg",
    alt: "Air Freight",
    caption: "Air Freight",
    width: 4532,
    height: 2009
  },
  {
    src:
      "/img/gallery/witalyshipping4.jpg",
    alt: "Sea Freight",
    caption: "Sea Freight",
    width: 532,
    height: 517
  },
  {
    src:
      "/img/gallery/witalyshipping1.jpg",
    alt: "Warehousing & Distribution",
    caption: "Warehousing & Distribution",
    width: 2532,
    height: 3725
  },
  {
    src: "/img/gallery/witalyshipping3.jpg",
    alt: "Transshipment & Project Cargo",
    caption: "Transshipment & Project Cargo",
    width: 2532,
    height: 1619
  }
  
];
